import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { MessageSquare } from 'lucide-react';
import { Typewriter } from 'react-simple-typewriter';
const AboutMeSection: React.FC = () => {
  return <section className="py-16 px-4 md:px-6 bg-gradient-to-r from-purple-50 to-amber-50">
      <div className="container mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-4xl md:text-5xl font-bold font-playfair bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-amber-600 pb-2">
            Untold Stories
          </h2>
          <p className="text-lg text-gray-600 mt-3 max-w-2xl mx-auto">Illuminating narratives that deserve to be shared with the world</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12">
          {/* Profile Card */}
          <div className="col-span-1">
            <Card className="overflow-hidden border-none shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-80 bg-gradient-to-b from-purple-200 to-purple-100">
                <img src="/lovable-uploads/08898862-7cb5-48fa-9643-000e9b5a8bce.png" alt="Sudesh Babu" className="w-full h-full object-cover object-center" />
              </div>
              <CardContent className="pt-6 pb-8 px-6 bg-white">
                <h3 className="text-2xl font-bold font-playfair mb-2">SUDESH BABU</h3>
                <p className="text-muted-foreground mb-4">Creating Value Is My Daily Job</p>
                
                
                
                <Button variant="outline" className="w-full border-purple-300 hover:bg-purple-50 hover:text-purple-700" asChild>
                  <a href="https://api.whatsapp.com/send/?phone=919347537540&text=Hello%20Sudesh,%20I%20found%20your%20profile%20and%20would%20like%20to%20connect!" target="_blank" rel="noopener noreferrer">
                    <MessageSquare className="mr-2 h-4 w-4" /> Connect
                  </a>
                </Button>
              </CardContent>
            </Card>
          </div>

          {/* About Content */}
          <div className="col-span-1 lg:col-span-2">
            <div className="h-full flex flex-col">
              <div className="mb-6">
                <h2 className="text-3xl md:text-4xl font-bold font-playfair mb-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-purple-900">
                  Manamu Media
                </h2>
                <div className="mb-4 flex items-center text-lg font-medium text-purple-800">
                  <span className="mr-2 text-zinc-800">Story begins to never end</span>
                  <Typewriter words={['తెలుగు', 'தமிழ்', 'हिन्दी', 'English']} loop={0} cursor cursorStyle='|' typeSpeed={70} deleteSpeed={50} delaySpeed={1000} />
                </div>
                <div className="prose max-w-none text-gray-600">
                  <p className="mb-4">
                    At Manamu Media, we believe that every story has the power to inspire, transform, and connect people across boundaries. Our platform is dedicated to discovering and sharing authentic narratives that might otherwise remain unheard in today's fast-paced media landscape.
                  </p>
                  <p className="mb-4">
                    Our team of passionate storytellers and creators work tirelessly to bring stories to light through powerful visuals, engaging content, and innovative media formats that resonate with audiences worldwide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default AboutMeSection;